import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";

const api = {
  [ActionTypes.settingActiveTabReport]: (tab) => tab,
  [ActionTypes.settingDataReport]: (data) => data,
  [ActionTypes.resetSettingDataReport]: () => {},
  [ActionTypes.settingTableReport]: (partial) => partial,
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
